import React, { useState, useEffect } from 'react'
import { Input } from 'antd'

const { TextArea } = Input

export default function CodeEditor({ value, onChange }) {
  const [text, setText] = useState('')
  const [error, setError] = useState(null)

  useEffect(() => {
    try {
      setText(JSON.stringify(value, null, 2))
      setError(null)
    } catch (e) {
      setText(String(value))
    }
  }, [value])

  const handleChange = (e) => {
    const newText = e.target.value
    setText(newText)
    try {
      const parsed = JSON.parse(newText)
      setError(null)
      onChange(parsed)
    } catch (e) {
      setError(e.message)
    }
  }

  return (
    <div>
      <TextArea
        value={text}
        onChange={handleChange}
        rows={12}
        style={{
          fontFamily: 'monospace',
          fontSize: 12,
          borderColor: error ? '#ff4d4f' : undefined
        }}
      />
      {error && (
        <div style={{ color: '#ff4d4f', fontSize: 12, marginTop: 4 }}>
          JSON Error: {error}
        </div>
      )}
    </div>
  )
}
